/** @jsxImportSource @emotion/react */
import { FEATURE_FLAGS } from '@app/app-constants'
import Navbar from '@app/components/ui/Navbar/Navbar'
import SidebarTrigger from '@app/components/ui/Sidebar/SidebarTrigger'
import { appLink } from '@app/config/appLink'
import { useFeatureFlags } from '@app/hooks/useFeatureFlags'
import { clientNameAtom } from '@app/state/clientsAtom'
import { generateLogoUrls } from '@app/utils/generateLogoUrls'
import { useAtomValue } from 'jotai'
import { useMemo } from 'react'

const RiskNavbar = () => {
  const clientName = useAtomValue(clientNameAtom)

  const logos = useMemo(() => generateLogoUrls(clientName), [clientName])
  const { useMultipleFeatureFlags } = useFeatureFlags()
  const isFeatureFlagsEnabled = useMultipleFeatureFlags([
    FEATURE_FLAGS.SUMMARY_PAGE,
    FEATURE_FLAGS.PRIORITISATION_PAGE,
    FEATURE_FLAGS.ADAPTATION_LIBRARY,
  ])

  return (
    <Navbar.Wrapper>
      <SidebarTrigger color="gray" />
      <Navbar.List>
        <Navbar.Item label="Overview" path={`${appLink.risk.path}/overview`} />
        <Navbar.Item label="Risk" path={`${appLink.risk.path}/explorer`} />
        {isFeatureFlagsEnabled[FEATURE_FLAGS.SUMMARY_PAGE] && (
          <Navbar.Item label="Summary" path={`${appLink.risk.path}/summary`} />
        )}
        {isFeatureFlagsEnabled[FEATURE_FLAGS.PRIORITISATION_PAGE] && (
          <Navbar.Item label="Prioritisation" path={`${appLink.risk.path}/prioritisation`} />
        )}
        <Navbar.Item label="Stories" path={`${appLink.risk.path}/stories`} />
        {isFeatureFlagsEnabled[FEATURE_FLAGS.ADAPTATION_LIBRARY] && (
          <Navbar.Item
            label="Adaptation Library"
            path={`${appLink.risk.path}/adaptation-library`}
          />
        )}
      </Navbar.List>
      <Navbar.Logo>
        <img src={logos.full} alt="Logo" />
      </Navbar.Logo>
    </Navbar.Wrapper>
  )
}

export default RiskNavbar
